import { render, staticRenderFns } from "./practicDetail.vue?vue&type=template&id=26dc8060&scoped=true"
import script from "./practicDetail.vue?vue&type=script&lang=js"
export * from "./practicDetail.vue?vue&type=script&lang=js"
import style0 from "./practicDetail.vue?vue&type=style&index=0&id=26dc8060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc8060",
  null
  
)

export default component.exports